export default __webpack_public_path__ + "d628af25af5bd5261c5a8f55c359b319.png";